<template>
  <div class="Registration logInComponent">
    <div class="logInContainer">
      <div class="logInCard">
        <div class="logoContainer">
          <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg" />
        </div>
        <validation-observer  v-slot="{ handleSubmit }" tag="div">
          <form @submit.prevent="handleSubmit(formSubmit)"  class="form form--login" >
            <div class="inputContainer">
              <div>
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input class="emailInput" placeholder="E-mail" name="E-mail" type="text" v-model="loginForm.email" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input placeholder="Full name" name="name" type="text" v-model="loginForm.name" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>               
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input placeholder="Company Name" name="name" type="text" v-model="loginForm.company_name" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>               
                <ValidationProvider :rules="{required: true, regex: /^(?=.*(?:\d|[^\dA-Za-z]))(?=.*[A-Z]).*$/}" vid="userPassword" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="passInput" placeholder="Jelszó" name="Password" type="password" v-model="loginForm.password" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider :rules="{required: true, confirmed:'userPassword'}" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="passInput" data-vv-as="password" placeholder="Password confirm" name="Jelszó" type="password" v-model="loginForm.passconf" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <div>
                  <md-radio v-model="loginForm.user_type" value="client">Client</md-radio>
                  <md-radio v-model="loginForm.user_type" value="account" >Agency</md-radio>
                </div>            
              </div>
              <div class="error--s" v-if="error.length > 0">{{error}}</div>
              <button type="submit" class="btn btn-green logInButton">Register</button>
              <p v-if="reg_success">Please confirm your e-mail address using the link in our message!</p>
              </div>
              <div class="text-link-login">
                  <router-link class="text-link " :to="{name: 'LogIn'}">Login</router-link>
                  
                </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import {
  ValidationProvider,
  extend,
} from "vee-validate/dist/vee-validate.full.esm";
import {required, regex, confirmed} from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} megadása kötelező."
});
extend('regex', {
  ...regex,
  message: "Your password must contain at least one uppercase letter, and one number or special character"
});
extend("confirmed", {
  ...confirmed,
  message: "Not the same password",
});

export default {
  data(){
    return{
      reg_success : false,
      loginForm:{
        email: null,
        password: null,
        passconf: null,
        user_type: 'client',
        company_name: '',
        payment_package_id: 1,

      },
      error: []
    }
  },
  components:{
    ValidationProvider,
    ValidationObserver        
  },
  methods:{
    formSubmit(){
        let _this = this

         _this.post('/register',
         _this.loginForm,
          {},function (response) {
            if (response.data.status == true)
          {
            _this.reg_success = true;
            _this.loginForm ={
              email: null,
              password: null,
              passconf: null,
              user_type: 'client',
              company_name: '',
              payment_package_id: 1,

            }
          }
            
          },function(error){
            //error
            //console.log('login error:', error.data)
            
            if (error.data.error == 'Not found!'){
              _this.error = 'Something went wrong!'
            }
          }
        )
    }
  }
}
</script>